export const GET_CARS = 'GET_CARS';

export const ADD_TO_PUBLICATIONS = 'ADD_TO_PUBLICATIONS';

export const GET_CARS_DETAIL = 'GET_CARS_DETAIL';

export const ORDER_CARS_ALF = 'ORDER_CARS_ALF';

export const GET_CAR_PUBLICATIONS = 'GET_CAR_PUBLICATIONS';

export const ORDER_CARS_KM = 'ORDER_CARS_KM';

export const ADD_TO_REVIEWS = 'ADD_TO_REVIEWS'; 

export const DELETE_REVIEW = ' DELETE_REVIEW';

export const ORDER_CARS_PRICE = 'ORDER_CARS_PRICE';

export const FILTER_BY_YEAR = 'FILTER_BY_YEAR';

export const FILTER_BY_BRAND = 'FILTER_BY_BRAND';

export const GET_CAR_BY_NAME = 'GET_CAR_BY_NAME';

export const GET_CAR_BY_BRAND = 'GET_CAR_BY_BRAND';

export const GET_CAR_BY_EMAIL = 'GET_CAR_BY_EMAIL';

export const SET_PAGE = 'SET_PAGE';

export const LOADING_ACTION = 'LOADING_ACTION';

export const PUT_CAR = 'PUT_CAR';

export const SEARCH_USER_ADMIN = 'SEARCH_USER_ADMIN ';

export const SEARCH_REVIEW_ADMIN= 'SEARCH_REVIEW_ADMIN';

export const DELETE_CAR = 'DELETE_CAR';

export const DELETE_CAR_ADMIN = 'DELETE_CAR_ADMIN';

export const POST_CAR = 'POST_CAR';

export const CLEAN_STATE = 'CLEAN_STATE';

export const ERROR_OCCURRED = 'ERROR_OCCURRED';

export const ADD_FAVORITE = 'ADD_FAVORITE';

export const REMOVE_FAVORITE = 'REMOVE_FAVORITE'

export const ALL_USERS = 'ALL_USERS';

export const CREATE_USER = 'CREATE_USER';

export const GET_USER_PROFILE = 'GET_USER_PROFILE';

export const GET_CAR_FAVORITES = 'GET_CAR_FAVORITES';

export const FILTER_BY_YEAR_AND_BRAND = 'FILTER_BY_YEAR_AND_BRAND';

export const USER_DELETE = "USER_DELETE";

export const GET_USERS_STATISTICS =  "GET_USERS_STATISTICS"

export const GET_CARS_STATISTICS = "GET_CARS_STATISTICS"